"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var scheduledTaskManagementRouter = {
  type: 1,
  path: '/sms-scheduled-task',
  component: _layout.default,
  redirect: '/table/scheduled-task',
  name: '',
  meta: {
    title: 'scheduledTaskTitle',
    icon: 'g-schedulling'
  },
  children: [{
    type: 2,
    path: 'scheduled-task',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-scheduled-task-management/scheduled-task'));
      });
    },
    name: 'job:view',
    meta: {
      title: 'scheduledTask'
    },
    children: [{
      path: 'update',
      name: 'job:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'job:delete',
      hidden: true
    }, {
      path: 'pause',
      name: 'job:pause',
      hidden: true
    }, {
      path: 'resume',
      name: 'job:resume',
      hidden: true
    }, {
      path: 'run',
      name: 'job:run',
      hidden: true
    }, {
      path: 'export',
      name: 'job:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'scheduled-task-log',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-scheduled-task-management/scheduled-task-log'));
      });
    },
    name: 'jobLog:view',
    meta: {
      title: 'scheduledTaskLog'
    },
    children: [{
      path: 'export',
      name: 'jobLog:export',
      hidden: true
    }]
  }]
};
var _default = scheduledTaskManagementRouter;
exports.default = _default;